import Labeled from 'admin/components/atoms/Labeled';
import React from 'react';
import styled, { StyledComponentPropsWithRef } from 'styled-components';

export const LabeledTable = styled.div`
  display: table;
`;

export const Row = styled.div`
  display: table-row;
  border-bottom: 1px solid #eee;
`;

const RightLabeled = (props: StyledComponentPropsWithRef<typeof Labeled>) => (
  <Labeled labelPosition="right" {...props} />
);
export const Label = styled(RightLabeled)`
  padding: 6px 0;
  display: table-cell;
  font-weight: 400;
  vertical-align: middle;
`;

export const Item = styled.div`
  padding: 6px 0;
  display: table-cell;
`;

export default LabeledTable;
